export default "__VITE_ASSET__CbL5lRfk__"